<div class="authentication-footer">
  <a href="https://antony-it.de" target="_blank">
    <img src="/assets/images/antony-horizontal.svg" alt="antony">
  </a>
  <p class="version mat-small mat-hint">{{ VERSION }}</p>
</div>
